import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-asnnumber-popup',
  templateUrl: './asnnumber-popup.component.html',
  styleUrls: ['./asnnumber-popup.component.scss']
})
export class ASNNumberPopupComponent {
  @Input() asnList: { asnNum: string, poNum:string }[] = [];
  @Input() popupContent: string = '';
  @Output() cancel = new EventEmitter<string>();

  onCancel(): void {
    this.cancel.emit('cancel');
  }

}
